import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogBody,
} from "@/components/ui/alert-dialog";
import { useRevokeApiKey } from "@/hooks/useApiKeyMutations";
import { toast } from "sonner";

interface RevokeApiKeyDialogProps {
  open: boolean;
  onClose: () => void;
  apiKeyId: string;
  apiKeyName: string;
}

export function RevokeApiKeyDialog({
  open,
  onClose,
  apiKeyId,
  apiKeyName,
}: RevokeApiKeyDialogProps) {
  const revokeApiKey = useRevokeApiKey();

  const handleConfirm = async () => {
    try {
      await revokeApiKey.mutateAsync(apiKeyId);
      onClose();
    } catch (error) {
      console.error("Failed to revoke API key:", error);
      toast.error("Failed to revoke API key");
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Revoke API Key</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogBody>
          <AlertDialogDescription>
            This will immediately invalidate <strong>{apiKeyName}</strong>. All
            requests using this key will be rejected.
          </AlertDialogDescription>
        </AlertDialogBody>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={revokeApiKey.isPending}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              handleConfirm();
            }}
            disabled={revokeApiKey.isPending}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {revokeApiKey.isPending ? "Revoking..." : "Revoke"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
